import { render, staticRenderFns } from "./v-radio-group.vue?vue&type=template&id=0123933d&scoped=true&"
import script from "./v-radio-group.vue?vue&type=script&lang=js&"
export * from "./v-radio-group.vue?vue&type=script&lang=js&"
import style0 from "./v-radio-group.vue?vue&type=style&index=0&id=0123933d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123933d",
  null
  
)

export default component.exports